<template>
  <div>
    <div v-for="file in files" :key="file.name" class="export-file-item">
      <div class="export-file-info">
        <el-icon class="el-icon-document" style="margin-right: 8px;"></el-icon>
        <span>{{ file.name }}</span>
      </div>
      <div class="export-file-status">
        <el-icon
          v-if="file.status === 'loading'"
          class="el-icon-loading"
          style="color: #409EFF;"
        ></el-icon>
        <el-icon
          v-else-if="file.status === 'completed'"
          class="el-icon-check"
          style="color: #67C23A;"
        ></el-icon>
        <el-icon
          v-else-if="file.status === 'error'"
          class="el-icon-close"
          style="color: #F56C6C;"
        ></el-icon>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FileDownloadStatus',
  props: {
    files: {
      type: Array,
      required: true,
      default: () => []
    }
  }
}
</script>

<style scoped>
.export-file-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid #f0f0f0;
}

.export-file-item:last-child {
  border-bottom: none;
}

.export-file-info {
  display: flex;
  align-items: center;
  flex: 1;
}

.export-file-status {
  display: flex;
  align-items: center;
  font-size: 18px;
}

.export-file-item .export-file-info span {
  font-size: 12px;
  line-height: 1.2;
  word-break: break-word;
}
</style>


// WEBPACK FOOTER //
// src/components/FileDownloadStatus.vue